import { o2oApi } from 'yxt-biz-pc/packages/api';

// 获取项目详情
export const getProjectInfo = (projectId, orgId) => {
  return o2oApi.get(`/external/project/baseInfo?projectId=${projectId}&orgId=${orgId}`);
};

// 项目集基本信息
export const getProjectIntegrate = (projectId) => {
  return o2oApi.get(`/projectIntegrate/get/${projectId}`);
};
